import React from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram } from 'lucide-react';
const LOGO = 'https://cdn.magicpatterns.com/uploads/baHRvKY6wDUBCxuqxUseKW/tulsawaterlogo.png';
const LINKS = {
  Company: [{
    label: 'Our Systems',
    href: '#products'
  }, {
    label: 'How It Works',
    href: '#how'
  }, {
    label: 'Gallery',
    href: '#gallery'
  }, {
    label: 'Reviews',
    href: '#reviews'
  }],
  Support: [{
    label: 'Service Areas',
    href: '#areas'
  }, {
    label: 'Get a Quote',
    href: '#quote'
  }, {
    label: 'Warranty',
    href: '#products'
  }, {
    label: 'Financing',
    href: '#quote'
  }]
};
export function Footer() {
  return <footer className="bg-navy-950 text-white" data-id="element-15" data-mp="3fe9vagukcxtm">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-16 sm:px-6 lg:grid-cols-4" data-id="element-16" data-mp="3kdmgyy9p7yum">
        <div className="lg:col-span-1" data-id="element-17" data-mp="by2rmac5f0ku">
          <img src={LOGO} alt="Tulsa Water Pros" className="h-14 w-auto" data-id="element-18" data-mp="bx1f01fhi610" />
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/60" data-id="element-19" data-mp="goj7s27ct0aw">
            Clean Water. Better Life. Family-owned water treatment and filtration serving the
            greater Tulsa, Oklahoma area.
          </p>
          <div className="mt-5 flex gap-3" data-id="element-20" data-mp="3ehklk8y5sull">
            <a href="#" aria-label="Facebook" className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 transition-colors hover:bg-brand-cyan" data-id="element-21" data-mp="3eeomghakrzvk">
              <Facebook className="h-4 w-4" data-id="element-22" data-mp="3ngehdx3o1gy3" />
            </a>
            <a href="#" aria-label="Instagram" className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 transition-colors hover:bg-brand-cyan" data-id="element-23" data-mp="606ml2usfqn1">
              <Instagram className="h-4 w-4" data-id="element-24" data-mp="13plz96ejjt2" />
            </a>
          </div>
        </div>

        {Object.entries(LINKS).map(([title, items]) => <div key={title} data-id="element-25" data-mp="azj8nldu4tok">
            <h3 className="text-sm font-bold uppercase tracking-wide text-white" data-id="element-26" data-mp="b0as5xu5r0yh">{title}</h3>
            <ul className="mt-4 space-y-3" data-id="element-27" data-mp="2gt9g6pz96jd6">
              {items.map(l => <li key={l.label} data-id="element-28" data-mp="2cs7g66xii3a5">
                  <a href={l.href} className="text-sm text-white/60 transition-colors hover:text-brand-cyan" data-id="element-29" data-mp="2ct8quaam8nrc">
                    {l.label}
                  </a>
                </li>)}
            </ul>
          </div>)}

        <div data-id="element-30" data-mp="po68zylb28g7">
          <h3 className="text-sm font-bold uppercase tracking-wide text-white" data-id="element-31" data-mp="pofxfhqpc7js">Get in touch</h3>
          <ul className="mt-4 space-y-3 text-sm text-white/60" data-id="element-32" data-mp="uo2btui9ntu6">
            <li className="flex items-center gap-2.5" data-id="element-33" data-mp="ypdu1eyt9csc">
              <Phone className="h-4 w-4 text-brand-cyan" data-id="element-34" data-mp="yoma51ekt3hw" />
              <a href="tel:+19185550123" className="hover:text-brand-cyan" data-id="element-35" data-mp="13o7a9f5hfhw7">(918) 555-0123</a>
            </li>
            <li className="flex items-center gap-2.5" data-id="element-36" data-mp="18enov2l1h9k5">
              <Mail className="h-4 w-4 text-brand-cyan" data-id="element-37" data-mp="18ha3tna9erce" />
              <a href="mailto:hello@tulsawaterpros.com" className="hover:text-brand-cyan" data-id="element-38" data-mp="1dd8mcu8wpf4w">hello@tulsawaterpros.com</a>
            </li>
            <li className="flex items-start gap-2.5" data-id="element-39" data-mp="1if7pc30qia1b">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand-cyan" data-id="element-40" data-mp="1me6vfqy7ccuc" />
              Tulsa, Oklahoma
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10" data-id="element-41" data-mp="36uo5zypix8le">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-6 text-xs text-white/50 sm:flex-row sm:px-6" data-id="element-42" data-mp="32ucj0f9ouw6r">
          <p data-id="element-43" data-mp="2xy5nlgex5332">© {new Date().getFullYear()} Tulsa Water Pros. All rights reserved.</p>
          <p className="flex gap-4" data-id="element-44" data-mp="2sz2la3qbpays">
            <a href="#" className="hover:text-white" data-id="element-45" data-mp="3qkqcma7x933g">Privacy Policy</a>
            <a href="#" className="hover:text-white" data-id="element-46" data-mp="3qmt3ewgwf098">Terms of Service</a>
          </p>
        </div>
      </div>
    </footer>;
}